export const runTimeEnv = typeof window === 'undefined' ? 'server' : 'client';
